/**
 * @generated SignedSource<<88d097bc97fa81e4be1fa1879afbeaa0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarEventItemListItem_eventItem$data = {
  readonly description: string | null;
  readonly title: string;
  readonly " $fragmentType": "CalendarEventItemListItem_eventItem";
};
export type CalendarEventItemListItem_eventItem$key = {
  readonly " $data"?: CalendarEventItemListItem_eventItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarEventItemListItem_eventItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CalendarEventItemListItem_eventItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "TeamScheduleOneOffEvent",
  "abstractKey": null
};

(node as any).hash = "efe3cae79856629347d45465d1e4d215";

export default node;
